import React from 'react';
import { Modal } from '../../components';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import CommunityCard from '../CommunityCard/CommunityCard';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';
import { createResourceLocatorString } from '../../util/routes';
import css from './SeeAllGroupModal.module.css';
const SeeAllGroupModal = props => {
  const {
    onSeeAllGroupClick,
    isSeeAllGroup,
    spaceListData,
    history,
    routeConfiguration,
    title,
    groups,
    isLoading = false,
    getCardData,
    getMembershipCardProps,
    buttonTextId,
  } = props;
  const fetchSpaceDetails = space => {
    const { id, slug } = space;
    onSeeAllGroupClick();
    return history.push(
      createResourceLocatorString(
        'DiscoverGroupsCommunityPage',
        routeConfiguration,
        { id, slug },
        {}
      )
    );
  };
  return (
    <>
      <Modal
        id="seeAllGroupModal"
        isOpen={isSeeAllGroup}
        onClose={onSeeAllGroupClick}
        onManageDisableScrolling={manageDisableScrolling}
        className={css.seeAllModal}
      >
        <div className={css.seeAllWrapper}>
          {title ? <h2 className={css.modalTitle}>{title}</h2> : null}
          {isLoading ? (
            <div className={css.loadingState} role="status">
              Loading groups...
            </div>
          ) : Array.isArray(groups) ? (
            groups.length ? (
              <div className={css.groupCardGrid}>
                {groups.map(group => {
                  const data = getCardData ? getCardData(group) : group;
                  const id = data?.id || data?.groupId || group?.id || group?.groupId;
                  return (
                    <CommunityCard
                      key={id}
                      className={css.groupCard}
                      data={data}
                      buttonTextId={buttonTextId || 'CircleSearchPage.groupCardButton'}
                      onViewGroup={fetchSpaceDetails}
                      {...(getMembershipCardProps ? getMembershipCardProps(group) : {})}
                    />
                  );
                })}
              </div>
            ) : (
              <div className={css.emptyState}>No groups found.</div>
            )
          ) : Array.isArray(spaceListData)
            ? spaceListData
              ?.filter(item => !item.is_member) //THQ-203 point 2.(a)

              .map(item => (
                <div className={css.seeall} key={item.id} onClick={() => fetchSpaceDetails(item)}>
                  <ProfileIconCard type="purple" />
                  <span>{item.name}</span>
                </div>
              ))
            : null}
        </div>
      </Modal>
    </>
  );
};

export default SeeAllGroupModal;
